export default __webpack_public_path__ + "static/media/element_52.13318a1d.webp";